import { BACKEND_URL } from "@/lib/api";
import { createContext, useContext, useEffect, useState } from "react";
import { PRICES, FAQ, TEXTS, REVIEWS, INSTAGRAM, IMG, STORIES } from "../data/content";
import { TEAM } from "../data/team";

const DEFAULTS = { prices: PRICES, faq: FAQ, texts: TEXTS, reviews: REVIEWS, instagram: INSTAGRAM, team: TEAM, images: IMG, stories: STORIES };
const ContentContext = createContext({ ...DEFAULTS, loaded: false, refresh: () => {} });

const clean = (obj = {}) => Object.fromEntries(Object.entries(obj).filter(([, v]) => v));

export const mergeContent = (remote = {}) => ({
  prices: remote.prices?.items?.length ? remote.prices.items.map((p) => ({ ...(PRICES.find((d) => d.name === p.name) || {}), ...p })) : PRICES,
  faq: remote.faq?.items?.length ? remote.faq.items : FAQ,
  texts: { ...TEXTS, ...(remote.texts || {}) },
  reviews: remote.reviews ? { ...REVIEWS, ...remote.reviews, items: remote.reviews.items?.length ? remote.reviews.items : REVIEWS.items } : REVIEWS,
  instagram: remote.instagram ? { ...INSTAGRAM, ...remote.instagram } : INSTAGRAM,
  team: remote.team?.items?.length ? remote.team.items.map((t) => ({ ...(TEAM.find((d) => d.name === t.name) || {}), ...t })) : TEAM,
  images: { ...IMG, ...clean(remote.images) },
  stories: remote.stories ? remote.stories.items || [] : STORIES,
});

export const imgUrl = (u = "") => (u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const ContentProvider = ({ children }) => {
  const [state, setState] = useState({ ...DEFAULTS, loaded: false });
  const refresh = () => fetch(`${BACKEND_URL}/api/content`).then((r) => (r.ok ? r.json() : {}))
    .then((d) => setState({ ...mergeContent(d), loaded: true })).catch(() => setState((s) => ({ ...s, loaded: true })));
  useEffect(() => { refresh(); }, []);
  return <ContentContext.Provider value={{ ...state, refresh }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
